"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeydownObserver = void 0;
const react_1 = __importDefault(require("react"));
class KeydownObserver extends react_1.default.Component {
  constructor() {
    super(...arguments);
    this.onKeyPressed = e => {
      const keyCode = e.keyCode;
      const _this$props = this.props,
        keys = _this$props.keys,
        onKeyPressed = _this$props.onKeyPressed,
        secondaryKey = _this$props.secondaryKey;
      if (secondaryKey) {
        if (keys.includes(keyCode) && e[secondaryKey]) {
          e.preventDefault();
          onKeyPressed(keyCode);
        }
      } else if (keys.includes(keyCode)) {
        e.preventDefault();
        onKeyPressed(keyCode);
      }
    };
  }
  componentDidMount() {
    document.addEventListener("keydown", this.onKeyPressed, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyPressed, false);
  }
  render() {
    return null;
  }
}
exports.KeydownObserver = KeydownObserver;
exports.default = KeydownObserver;